/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  GridColumnMenuFilter,
  GridColumnMenuItem,
  GridColumnMenuItemContent,
  GridColumnMenuItemGroup,
  GridColumnMenuProps,
  GridColumnMenuSort,
} from '@progress/kendo-react-grid';
import React, { FormEvent, useState } from 'react';
import Checkbox from '../shared/Checkbox';
import { IColumn } from './GridColumns';

interface IProps {
  defaultColumns?: IColumn[];
  gridColumnProps: GridColumnMenuProps;
  notFilterable: boolean | undefined;
  noColumnMenu: boolean | undefined;
  twoFilterCriteria: boolean | undefined;
  onColumnsSubmit?: (columns: IColumn[]) => void;
  onColumnsReset?: () => void;
}

const GridColumnMenu: React.FC<IProps> = ({
  defaultColumns,
  gridColumnProps,
  notFilterable,
  noColumnMenu,
  twoFilterCriteria,
  onColumnsSubmit,
  onColumnsReset,
}) => {
  const [columns, setColumns] = React.useState<IColumn[] | null>(defaultColumns ? defaultColumns : null);
  const [columnsExpanded, setColumnsExpanded] = useState<boolean>(false);
  const [filtersExpanded, setFiltersExpanded] = useState<boolean>(false);

  const onColumnExpandChange = () => {
    const value = !columnsExpanded;
    setColumnsExpanded(value);
    setFiltersExpanded(value ? false : filtersExpanded);
  };

  const onFilterExpandChange = (value: boolean) => {
    setFiltersExpanded(value);
    setColumnsExpanded(value ? false : columnsExpanded);
  };

  const onToggleColumn = (displayColumn: IColumn) => {
    if (columns) {
      const newColumns = columns.map((column) => {
        return displayColumn.field === column.field ? { ...column, show: !column.show } : column;
      });
      setColumns(newColumns);
    }
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault();
    }
    if (columns && onColumnsSubmit) onColumnsSubmit(columns);
    if (gridColumnProps.onCloseMenu) {
      gridColumnProps.onCloseMenu();
    }
  };

  const onReset = (e: FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault();
    }
    if (onColumnsReset) onColumnsReset();
    if (gridColumnProps.onCloseMenu) {
      gridColumnProps.onCloseMenu();
    }
  };

  return (
    <div>
      <GridColumnMenuSort {...gridColumnProps} />
      {!notFilterable && (
        <GridColumnMenuFilter
          {...gridColumnProps}
          hideSecondFilter={!twoFilterCriteria}
          expanded={filtersExpanded}
          onExpandChange={onFilterExpandChange}
        />
      )}
      {columns && (
        <GridColumnMenuItemGroup>
          {!noColumnMenu && (
            <GridColumnMenuItem title={'Columns'} iconClass={'k-i-columns'} onClick={onColumnExpandChange} />
          )}
          {/*
        // @ts-ignore */}
          <GridColumnMenuItemContent show={columnsExpanded}>
            <div className={'k-column-list-wrapper'}>
              <form onSubmit={onSubmit} onReset={onReset}>
                <div className={'k-column-list'}>
                  {[...columns]
                    .sort((a, b) => (a.alwaysVisible === b.alwaysVisible ? 0 : a.alwaysVisible ? 1 : -1))
                    .map((column) => (
                      <div
                        key={column.field}
                        className={'k-column-list-item'}
                        onClick={() => {
                          if (!column.alwaysVisible) onToggleColumn(column);
                        }}
                      >
                        <span>
                          <Checkbox id="cbxColumn" disabled={column.alwaysVisible} isChecked={column.show} />
                          <label className="k-checkbox-label" style={{ userSelect: 'none', marginLeft: '5px' }}>
                            {column.title}
                          </label>
                        </span>
                      </div>
                    ))}
                </div>
                <div className={'k-actions k-hstack k-justify-content-stretch'}>
                  <button
                    type={'reset'}
                    className={'k-button k-button-md k-rounded-md k-button-solid k-button-solid-base'}
                  >
                    Reset
                  </button>
                  <button className={'k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary'}>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </GridColumnMenuItemContent>
        </GridColumnMenuItemGroup>
      )}
    </div>
  );
};

export default GridColumnMenu;
